export const DisabledFeatures = {
    features: {
        mobile: {
            mobile: true,
            desktop: false,
            appLinks: true,
            landingShopByCategory: true,
            hiringLink: false,
            autoreadOTP: false
        },

        desktop: {
            mobile: false,
            desktop: true,
            appLinks: true,
            landingShopByCategory: true,
            hiringLink: false,
            autoreadOTP: false
        }
    }
};

export const AllowedFeatures = {
    features: {
        mobile: {
            googleLogin: true,
            googleMap: true,
            tagManager: true,
            fbAnalytics: true,
            lottie: true,
            hls: true
        },

        desktop: {
            googleLogin: true,
            googleMap: true,
            tagManager: true,
            fbAnalytics: true,
            lottie: true,
            hls: true
        }
    }
};
